import React, { useState } from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormLabel from "@material-ui/core/FormLabel";

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../../styles";
import SimpleTextComponent from "./SimpleTextComponent";
import AddressComponent from "./AddressComponent";
import EmailComponent from "./EmailComponent";
import PhoneComponent from "./PhoneComponent";

const CardFormComponent = (props) => {
    const { classes }  = props;
    const selectDefaultValue = props.schema.type.dropdownOptions[props.iteration][0];

    const [selectedValue, setSelectedValue] = useState(selectDefaultValue);

    let shouldAppear = (value) => {
        return selectedValue === value ? true : false;
    }

    return (
        <div>
            <GridContainer
                className={classes.containerLine}
            >
                <GridItem xs={6}>
                    <FormLabel className={classes.labelHorizontal}>
                        Please select item
                    </FormLabel>
                </GridItem>
                <GridItem xs={6}>
                    <Select
                        className={classes.select}
                        onChange={(event) => {
                                setSelectedValue(event.target.value)
                                props.handleChange("select", event.target.value, props.iteration, false)
                            }}
                        defaultValue={selectDefaultValue}
                    >
                        {props.schema.type.dropdownOptions.map((element, key) => {
                            if (Array.isArray(element)) {
                                return (
                                <MenuItem
                                    key={key}
                                    classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected,
                                    }}
                                    value={element[0]}
                                >
                                    {element[1]}
                                </MenuItem>
                                );
                            } else {
                                return (
                                <MenuItem
                                    key={key}
                                    classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected,
                                    }}
                                    value={element}
                                >
                                    {element}
                                </MenuItem>
                                );
                            }
                        })}
                    </Select>
                </GridItem>
            </GridContainer>
            {shouldAppear("name") || shouldAppear("other") ?
                <SimpleTextComponent
                    selectedValue={selectedValue}
                    iteration={props.iteration}
                    handleChange={props.handleChange}
                    apiRegex={props.apiRegex}
                />
             : null}
             {shouldAppear("address") ?
                <AddressComponent
                    iteration={props.iteration}
                    handleChange={props.handleChange}
                    apiRegex={props.apiRegex}
                /> 
             : null}
             {shouldAppear("email") ?
                <EmailComponent
                    selectedValue={selectedValue}
                    iteration={props.iteration}
                    handleChange={props.handleChange}
                    apiRegex={props.apiRegex}
                    userInfo={props.userInfo}
                    selectDefaultValue={selectDefaultValue}
                />
             : null}
             {shouldAppear("phone") ?
                <PhoneComponent
                    selectedValue={selectedValue}
                    iteration={props.iteration}
                    handleChange={props.handleChange}
                    apiRegex={props.apiRegex}
                    userInfo={props.userInfo}
                    selectDefaultValue={selectDefaultValue}
                />
             : null}
        </div>
    );
}

export default withStyles(styles)(CardFormComponent)

